<template>
    <div id="cer_list">
        <div class="cer_news">
            <div class="cer-top">
                <div class="cer_top_text">证书名称</div>
                <div class="cer_top_text">证书编号</div>
                <div class="cer_top_text">发放单位</div>
                <div class="cer_top_text">有效期</div>
                <div class="cer_btn">操作</div>
            </div>
        </div>
        <div class="cer_list">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "PersonalCerficate",
    methods: {
        childByValue(childValue) {
            alert(childValue);
        },
    },
};
</script>



<style scoped>
.cer_top_text{
    width: 208px;
    text-align: center;
}
.cer-top{
    width: 100%;
    display: flex;
    flex-direction: row;
}
.cer_news{
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #9e9e9e;
    height: 30px;
    background: #f5f5f5;
}
#cer_list {
    display: flex;
    flex-direction: column;
    width: 100%;
}
</style>
